import { render } from "./App.vue?vue&type=template&id=54e58e8c&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=54e58e8c&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/FrontEnd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e58e8c"]])

export default __exports__